import { Component } from '@angular/core';
import { of } from 'rxjs';
import { InputContentDataType } from 'client/models';
import { createOptionGrouper } from 'common/helper';
import { DetailInfoTypeComponent } from '../detail-info-type.component';

@Component({
  selector: 'detail-info-select',
  templateUrl: './detail-info-select.component.html',
  standalone: false
})
export class DetailInfoSelectComponent extends DetailInfoTypeComponent {
  // Groups follow the LIVE options emission: static fields render the inputContentDatas set
  // below; rule-driven fields (DynamicMulti - allocated staff etc.) render the options the
  // base swaps into optionsObs when ExecuteRule returns. A one-shot ngOnInit grouping missed
  // that swap and rendered rule-populated dropdowns empty.
  public optionGroupsFor = createOptionGrouper<InputContentDataType>((o) => o.heading);

  override ngOnInit() {
    super.ngOnInit();
    Promise.resolve().then(() => {
      this.optionsObs = of(this.detailInfo.inputContentDatas || []);
    });
  }
}
